<template>
  <div class="checkout" :class="{ checkoutIsActive: showOrderInfo }">
    <button
      class="cart-button"
      :class="checkoutButtonClasses"
      @click="onClickCheckoutBtn()"
    >
      <i class="cart__icon fa fa-shopping-cart"></i>
      <span class="text-hidden"></span>
      <span class="cart__count">{{ getCountOfItemsInCart }}</span>
    </button>
    <div class="checkout__order popup">
      <div class="checkout__order-inner">
        <table class="checkout__summary">
          <thead>
            <tr>
              <th>Your Order</th>
              <th>Price</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th colspan="2">
                Total <span class="checkout__total">{{ cartTotal }}</span>
              </th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="item in cartItems" :key="item.key">
              <td>
                {{ item.name }}
                <span>X {{ item.quantity }}</span>
                <span
                  ><i
                    class="el-icon-delete ml-2 checkout__deleteItemBtn"
                    @click="onClickDeleteItem(item.key)"
                  ></i
                ></span>
              </td>
              <td>{{ item.displayPrice }}</td>
            </tr>
          </tbody>
        </table>
        <!-- /checkout__summary -->
        <div class="checkout__option" @click="onClickBuyNowBtn()">
          <el-icon name="truck mr-2"></el-icon>Checkout
        </div>
        <div class="checkout__close checkout__cancel">
          <i
            class="checkout-icon fas fa-times fa-close"
            @click="onClickCloseCheckoutBtn()"
          ></i
          >Close
        </div>
      </div>
      <!-- /checkout__order-inner -->
    </div>
    <!-- /checkout__order -->
  </div>
  <!-- /checkout -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { STR_MUTATION_UI_SET_CART_ICON_SHOWING_ORDER_INFO } from "../../../vuex/modules/ui/mutation-types";
export default {
  name: "CartIcon",
  data() {
    return {
      buttonClass: ""
    };
  },
  computed: {
    ...mapGetters([
      "getCountOfItemsInCart",
      "getClientCartOrderSummary",
      "uiCartIconIsShowingOrderInfo"
    ]),
    showOrderInfo: {
      get() {
        return this.uiCartIconIsShowingOrderInfo;
      },
      set(inBShowOrderInfo) {
        this.$store.commit(
          STR_MUTATION_UI_SET_CART_ICON_SHOWING_ORDER_INFO,
          inBShowOrderInfo
        );
      }
    },
    cartHasItems() {
      return this.getCountOfItemsInCart > 0;
    },
    cartItems() {
      const summary = this.getClientCartOrderSummary;
      if (summary) {
        return summary.items;
      }
      return null;
    },
    cartTotal() {
      const summary = this.getClientCartOrderSummary;
      if (summary) {
        return summary.displayTotal;
      }
      return null;
    },
    checkoutButtonClasses() {
      let classes = this.buttonClass;
      if (this.cartHasItems) {
        classes = `${classes} clickable`;
      }
      return classes;
    }
  },
  methods: {
    ...mapActions(["removeItemFromCart"]),
    onClickCheckoutBtn() {
      if (this.getCountOfItemsInCart > 0) {
        this.showOrderInfo = true;
      }
    },
    onClickCloseCheckoutBtn() {
      this.showOrderInfo = false;
    },
    onClickDeleteItem(itemKey) {
      const item = this.cartItems.find(item => item.key === itemKey);
      this.removeItemFromCart(item.productId);
      if (this.getCountOfItemsInCart === 0) {
        this.showOrderInfo = false;
      }
    },
    onClickBuyNowBtn() {
      this.showOrderInfo = false;
      this.$router.push({ name: `checkout` });
    }
  },
  watch: {
    getCountOfItemsInCart: function(newValue) {
      // animate the shopping cart icon when the user adds/removes a product
      this.buttonClass = "cart--animate";
      // slideout the cart order summary #todo maybe don't do this on mobile?
      if (newValue > 0) {
        this.showOrderInfo = true;
        setTimeout(() => {
          this.buttonClass = "";
        }, 200);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/sass/cart.scss";
</style>
